import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_bdf-method-eval/artifacts/7konbb84_trasparente.png";

export const BDFLogo = ({ className = "", size = "md" }) => {
  const heights = {
    sm: "h-12",
    md: "h-16",
    lg: "h-20",
  };
  return (
    <div className={`flex items-center ${className}`} data-testid="bdf-logo">
      <img
        src={LOGO_URL}
        alt="Metodo BDF - Eliana Bassotto"
        className={`${heights[size] || heights.md} w-auto object-contain block`}
      />
    </div>
  );
};

export default BDFLogo;
